export const reviews = [
    {
      id: 1,
      image:
        '/jennifer.jpg',
      name: 'Bootcamper: Jennifer Yashi',
    text: 'I was quite satisfied with how Chris taught how to face a task by drawing it on paper and breaking it down into smaller chunks BEFORE attempting to code.',
      rating: 5,
    },
    {
      id: 2,
      image:
        'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
      name: 'Jane Smith',
      text: 'From neural networks to AI ethics, Chris offers valuable insights and guidance that have been essential in my AI learning journey.',
      rating: 5,
    },
    {
      id: 3,
      image:
        '/matthew.jpg',
      name: 'Bootcamper: Matthew England',
      text: 'The boot camp was much harder than anticipated.The sheer amount of content to learn was at times overwhelming. However, Chris was there every step of the way to guide us through.',
      rating: 5,
    },
    {
      id: 4,
      image:
        'https://plus.unsplash.com/premium_photo-1671823917954-dc943c1bd9df?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
      name: 'Emily Davis',
      text: 'Whether discussing machine learning models or the ethical implications of AI, Chris makes everything clear and engaging. Highly recommend him for anyone looking to dive into AI!',
      rating: 5,
    },
    {
      id: 5,
      image:
        'https://images.unsplash.com/photo-1564564321837-a57b7070ac4f?q=80&w=1776&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
      name: 'David Miller',
      text: "Chris has an exceptional grasp of AI and its many facets. His ability to explain intricate AI concepts and real-world applications with clarity is amazing.",
      rating: 5,
    },
  ];